export default "__VITE_ASSET__6g$ufOV1__"